import { useMemo } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ChatCard from "../ChatCard/ChatCard";
import Logo from "../../../components/Logo/Logo";
import { selectBlockedUserIds } from "../../../slices/blocksSlice";

const ChatList = ({ chats, onSelectChat }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const blockedIds = useSelector(selectBlockedUserIds);
  const visibleChats = useMemo(
    () =>
      (chats || []).filter(
        (c) => c.participant?._id && !blockedIds.includes(c.participant._id)
      ),
    [chats, blockedIds]
  );

  return (
    <div className="min-h-full bg-background">
      {/* Header */}
      <div className="bg-white px-3 sm:px-4 md:px-6 py-2.5 sm:py-3 border-b border-border sticky top-0 z-10">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between">
            <div>
              <motion.h1
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="text-lg sm:text-xl md:text-2xl font-bold text-foreground"
              >
                {t('messages', 'Messages')}
              </motion.h1>
              <p className="text-xs sm:text-sm text-muted-foreground mt-0.5 sm:mt-1">
                {visibleChats.length} {visibleChats.length === 1 ? t('conversation', 'conversation') : t('conversations', 'conversations')}
              </p>
            </div>
            <button 
              onClick={() => navigate('/')}
              className="cursor-pointer hover:opacity-80 transition-opacity"
              aria-label={t('go_to_home', 'Go to home')}
            >
              <Logo className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 flex-shrink-0" />
            </button>
          </div>
        </div>
      </div>

      {/* Conversations List */}
      <div className="max-w-4xl mx-auto divide-y divide-border">
        {visibleChats.map((chat, index) => (
          <motion.div
            key={chat._id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.05 }}
          >
            <ChatCard chat={chat} onSelect={onSelectChat} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ChatList;
